
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import TitlePage from '@/components/atoms/TitlePage.vue'
import TextFrame from '@/components/atoms/TextFrame.vue'
import InputText from '@/components/molecules/InputText.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'

/**
 * パスワード再設定要求ページのフォーマット
 */
@Component({
  components: {
    ImageBase,
    TitlePage,
    TextFrame,
    InputText,
    ButtonSubmit,
    PanelFrame,
  },
})
export default class PasswordReminder extends Vue {
  /** 送信ボタン押下時のイベント */
  @Prop()
  private eventSubmit!: (loginId: string) => Promise<void>

  /** ログインID */
  private loginId: string = ''

  /**
   * 入力チェック
   *
   * @returns 未入力の場合は送信ボタンを無効化
   */
  private get isBlanked(): boolean {
    return this.loginId === ''
  }

  /**
   * 送信ボタン押下時処理
   */
  private async submit(): Promise<void> {
    await this.eventSubmit(this.loginId)
  }
}
